export default __webpack_public_path__ + "static/media/ic_uni_40.01dc29e6.svg";